__webpack_require__.p = "/new-talent-pools-data-access/referrals-hub/";